import { TimeAttributeProps } from 'Types/Attribute.types'
import { TimePicker } from 'antd/lib'
import React, { useCallback } from 'react'
import './Time.less'
import dayjs from 'dayjs'

const TimeAttribute: React.FC<TimeAttributeProps> = props => {
    const handleChange = useCallback(
        (_: dayjs.Dayjs | null, timeString: string | string[]) => {
            props.onChange(timeString ? (timeString as string) : undefined)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="time-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <TimePicker
                placeholder="Please enter value"
                value={props.value ? dayjs(props.value, 'hh:mm:ss') : null}
                onChange={handleChange}
                allowClear
                disabled={props.readonly}
            />
        </div>
    )
}

export default TimeAttribute
